import { Box, Flex } from '@chakra-ui/layout';
import { Button, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { AddPricingOptionModal } from './AddPricingOptionModal';
import { PricingOptionsTable } from './PricingOptionsTable';
import { Icon } from 'packages/common-frontend/components/icons/fontAwesome';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';
import { Typography } from '~/packages/common-frontend/components/Typography';

export const PricingOptionsSummary = () => {
  const creditAgreement = useCreditAgreementStore(
    (store) => store.creditAgreement,
  );
  const disclosure = useDisclosure();

  return (
    <Flex direction="column" gap="1.5rem">
      <Flex justifyContent="space-between">
        <Box>
          <Typography variant="page-title">Pricing Options</Typography>
          <Typography variant="base-muted">
            A Pricing Option is a configurable, named pricing structure that can
            be applied across multiple commitments to inform loan management; it
            is needed to add a commitment and create a loan. Select &apos;Review
            Changes&apos; to submit for approval.
          </Typography>
        </Box>

        <AddPricingOptionModal disclosure={disclosure} />
        <Button
          colorScheme="v2-aurora"
          flexShrink={0}
          leftIcon={<Icon icon="plus" />}
          onClick={disclosure.onOpen}
          variant="outline"
        >
          Add Pricing Option
        </Button>
      </Flex>
      {!!creditAgreement?.loanMechanicsV1?.pricingOptions?.length && (
        <PricingOptionsTable />
      )}
    </Flex>
  );
};
